import { FORMATS, makeCustomFormatter } from "helpers/formatters/numbers"
import { toLower, replace } from "lodash"

export const valueFormatter = makeCustomFormatter(FORMATS.SMALL_NUMBER_FORMAT, { autoFormat: true, emptyValueFiller: "" })
export const numericValueRegex = /^(?<numeric>[+-]?(?:\d*\.)?\d+)$/
export const numericValueWithSuffixRegex = /^(?<numeric>[+-]?(?:\d*\.)?\d+)\s{0,1}(?<multiplier>[kKmMbB]?)$/

export function getRealValue(value) {
  const trimmedValue = replace(value, /\s/gi, "")
  const match = numericValueWithSuffixRegex.exec(trimmedValue)
  // If the Regex doesn't match, don't transform the value
  if (!match) { return value }

  const { numeric, multiplier } = match.groups
  if (toLower(multiplier) === "k") {
    return numeric * 1000
  }
  if (toLower(multiplier) === "m") {
    return numeric * 1000000
  }
  if (toLower(multiplier) === "b") {
    return numeric * 1000000000
  }
  return numeric
}
